import { authClient, API } from "../index";

export const getRoles = (accessToken) => {
	return authClient(accessToken).get(`${API}/roles`);
};
